import React, { useEffect, useState, useRef } from 'react';
import '../components-css/sop.scss';
import { Link } from "react-router-dom";
import axios from 'axios';

export default function SOPPage() {
    const [isAuthorized, setIsAuthorized] = useState(false);
    const [isChecking, setIsChecking] = useState(true);
    const [obscureContent, setObscureContent] = useState(false);
    const [activeId, setActiveId] = useState('');
    const [step, setStep] = useState('checking'); // checking | email | otp | sop
    const [email, setEmail] = useState('');
    const [otp, setOtp] = useState('');

    const tocRef = useRef(null);
    useIdleLogout(setStep);

    const tocItems = [
        { id: 'lead-flow', label: 'Lead Flow & Assignment' },
        { id: 'crm-lead-status', label: 'CRM Lead Status (Mandatory)' },
        { id: 'contact-management', label: 'Contact Management & Networking' },
        { id: 'follow-up', label: '5-Days Follow-Up Process' },
        { id: 'communication', label: 'Communication Guidelines' },
        { id: 'crm-discipline', label: 'CRM Discipline (Strictly Mandatory)' },
        { id: 'compliance', label: 'Compliance Note' },
    ];

    const scrollToSection = (id) => {
        setActiveId(id);
      
        const element = document.getElementById(id);
        if (!element) return;
      
        const yOffset = -100; // header / spacing
        const y =
          element.getBoundingClientRect().top + window.pageYOffset + yOffset;
      
        window.scrollTo({
          top: y,
          behavior: 'smooth',
        });
      };
      
    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        setActiveId(entry.target.id);
                    }
                });
            },
            {
                rootMargin: '-50% 0px -50% 0px',
            }
        );

        tocItems.forEach((item) => {
            const el = document.getElementById(item.id);
            if (el) observer.observe(el);
        });

        return () => observer.disconnect();
    }, []);

    useEffect(() => {
        const preventContextMenu = (e) => e.preventDefault();

        const isBlockedCombo = (e) => {
            const key = e.key?.toLowerCase();

            // Windows screenshot
            if (key === 'printscreen') return true;

            // Devtools / save / print / view-source (best effort)
            if (
                (e.ctrlKey || e.metaKey) &&
                ['s', 'p', 'u', 'i', 'j', 'c'].includes(key)
            ) {
                return true;
            }

            // F12 (devtools)
            if (key === 'f12') return true;

            return false;
        };

        const handleKeyDown = (e) => {
            if (isBlockedCombo(e)) {
                e.preventDefault();
                setObscureContent(true);
                return;
            }

            // Any Ctrl / Cmd press → obscure
            if (e.ctrlKey || e.metaKey) {
                setObscureContent(true);
            }
        };

        const handleKeyUp = (e) => {
            if (!e.ctrlKey && !e.metaKey) {
                setObscureContent(false);
            }
        };

        // 🔥 THIS protects macOS screenshots
        const handleBlur = () => {
            setObscureContent(true);
        };

        const handleFocus = () => {
            setTimeout(() => setObscureContent(false), 300);
        };

        const handleVisibilityChange = () => {
            if (document.hidden) {
                setObscureContent(true);
            } else {
                setTimeout(() => setObscureContent(false), 300);
            }
        };

        const preventSelection = (e) => e.preventDefault();
        const preventDrag = (e) => e.preventDefault();

        document.addEventListener('contextmenu', preventContextMenu);
        document.addEventListener('keydown', handleKeyDown);
        document.addEventListener('keyup', handleKeyUp);
        document.addEventListener('visibilitychange', handleVisibilityChange);
        document.addEventListener('selectstart', preventSelection);
        document.addEventListener('dragstart', preventDrag);
        document.addEventListener('copy', preventSelection);
        document.addEventListener('cut', preventSelection);
        window.addEventListener('blur', handleBlur);
        window.addEventListener('focus', handleFocus);

        return () => {
            document.removeEventListener('contextmenu', preventContextMenu);
            document.removeEventListener('keydown', handleKeyDown);
            document.removeEventListener('keyup', handleKeyUp);
            document.removeEventListener('visibilitychange', handleVisibilityChange);
            document.removeEventListener('selectstart', preventSelection);
            document.removeEventListener('dragstart', preventDrag);
            document.removeEventListener('copy', preventSelection);
            document.removeEventListener('cut', preventSelection);
            window.removeEventListener('blur', handleBlur);
            window.removeEventListener('focus', handleFocus);
        };
    }, []);

    useEffect(() => {
        const token = localStorage.getItem('authToken');

        if (!token) {
            setStep('email');
            return;
        }

        axios
            .get('https://newomkatech.omkatech.in/api/check-token', {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            })
            .then(() => setStep('sop'))
            .catch(() => {
                localStorage.removeItem('authToken');
                setStep('email');
            });
    }, []);

    const sendOtp = async () => {
        if (!email) return alert('Enter email');

        try {
            setStep('otp');
            await axios.post('https://newomkatech.omkatech.in/api/send-otp', { email });
        } catch {
            alert('Failed to send OTP');
        }
    };

    const verifyOtp = async () => {
        if (!otp) {
            alert('Enter OTP');
            return;
        }

        try {
            const res = await axios.post(
                'https://newomkatech.omkatech.in/api/match-otp',
                { otp }
            );

            // 🚨 VALIDATION CHECK
            if (!res.data?.status) {
                alert(res.data?.message || 'Invalid OTP');
                return;
            }

            // ✅ SUCCESS CASE ONLY
            localStorage.setItem('authToken', res.data.token);
            setStep('sop');

        } catch (err) {
            alert('OTP verification failed. Please try again.');
        }
    };
    useEffect(() => {
        let raf;

        const init = () => {
            const toc = tocRef.current;
            if (!toc) {
                raf = requestAnimationFrame(init);
                return;
            }

            const onScroll = () => {
                if (window.scrollY > 420) {
                    toc.classList.add('fixed');
                } else {
                    toc.classList.remove('fixed');
                }
            };

            window.addEventListener('scroll', onScroll);

            return () => window.removeEventListener('scroll', onScroll);
        };

        raf = requestAnimationFrame(init);

        return () => cancelAnimationFrame(raf);
    }, []);



    // useEffect(() => {
    //     // Check if user is on OMKATECH WiFi
    //     const checkNetwork = async () => {
    //         try {
    //             // Method 1: Check IP address range (you need to configure your allowed IP range)
    //             const response = await fetch('https://api.ipify.org?format=json');
    //             const data = await response.json();
    //             console.log('data', data)
    //             const userIP = data.ip;

    //             // Replace these with your actual OMKATECH office IP addresses or IP range
    //             const allowedIPs = [
    //                 '103.44.52.129', // Example - Replace with your actual office IP
    //                 '103.44.52.163',
    //                 '103.44.52.175',
    //                 '103.44.52.160'
    //                 // Add more IPs as needed
    //             ];

    //             // Check if IP matches
    //             const isAllowedIP = allowedIPs.includes(userIP);
    //             console.log('is;;', isAllowedIP)

    //             // Method 2: You can also check custom header from your router/firewall
    //             // This requires server-side configuration

    //             if (isAllowedIP) {
    //                 setIsAuthorized(true);
    //             } else {
    //                 setIsAuthorized(false);
    //                 alert('⛔ Access Denied: This page can only be accessed from OMKATECH office WiFi network.');
    //             }
    //         } catch (error) {
    //             console.error('Network check failed:', error);
    //             setIsAuthorized(false);
    //             alert('⛔ Unable to verify network. Please ensure you are connected to OMKATECH WiFi.');
    //         } finally {
    //             setIsChecking(false);
    //         }
    //     };

    //     checkNetwork();
    // }, []);

    useEffect(() => {
        if (!isAuthorized) return;

        // Disable right-click context menu
        const disableRightClick = (e) => {
          e.preventDefault();
          alert('⛔ Right-click is disabled for security reasons.');
          return false;
        };

        // Disable keyboard shortcuts for screenshots and developer tools
        const disableKeyboardShortcuts = (e) => {
          // Disable PrintScreen
          if (e.key === 'PrintScreen') {
            e.preventDefault();
            navigator.clipboard.writeText('');
            document.body.style.display = 'none';
            setTimeout(() => {
              document.body.style.display = 'block';
            }, 100);
            alert('⛔ Screenshots are disabled. This attempt has been logged.');
            return false;
          }

          // Disable Windows + Shift + S (Snipping Tool)
          if (e.key === 's' && e.shiftKey && e.metaKey) {
            e.preventDefault();
            alert('⛔ Screenshot tools are disabled.');
            return false;
          }

          // Disable Ctrl+P (Print)
          if ((e.ctrlKey || e.metaKey) && e.key === 'p') {
            e.preventDefault();
            alert('⛔ Printing is disabled for security reasons.');
            return false;
          }

          // Disable Ctrl+S (Save)
          if ((e.ctrlKey || e.metaKey) && e.key === 's') {
            e.preventDefault();
            alert('⛔ Saving is disabled for security reasons.');
            return false;
          }

          // Disable Ctrl+C (Copy)
          if ((e.ctrlKey || e.metaKey) && e.key === 'c') {
            e.preventDefault();
            alert('⛔ Copying is disabled for security reasons.');
            return false;
          }

          // Disable Ctrl+X (Cut)
          if ((e.ctrlKey || e.metaKey) && e.key === 'x') {
            e.preventDefault();
            alert('⛔ Cutting is disabled for security reasons.');
            return false;
          }

          // Disable Ctrl+A (Select All)
          if ((e.ctrlKey || e.metaKey) && e.key === 'a') {
            e.preventDefault();
            return false;
          }

          // Disable F12 and Ctrl+Shift+I (Developer Tools)
          if (e.key === 'F12' || ((e.ctrlKey || e.metaKey) && e.shiftKey && e.key === 'I')) {
            e.preventDefault();
            return false;
          }

          // Disable Ctrl+U (View Source)
          if ((e.ctrlKey || e.metaKey) && e.key === 'u') {
            e.preventDefault();
            return false;
          }

          // Disable Ctrl+Shift+C (Inspect Element)
          if ((e.ctrlKey || e.metaKey) && e.shiftKey && e.key === 'C') {
            e.preventDefault();
            return false;
          }

          // Disable Ctrl+Shift+J (Console)
          if ((e.ctrlKey || e.metaKey) && e.shiftKey && e.key === 'J') {
            e.preventDefault();
            return false;
          }
        };

        // Disable text selection
        const disableSelection = (e) => {
            e.preventDefault();
            return false;
        };

        // Disable copy
        const disableCopy = (e) => {
            e.preventDefault();
            e.clipboardData.setData('text/plain', '');
            alert('⛔ Copying is disabled for security reasons.');
            return false;
        };

        // Disable cut
        const disableCut = (e) => {
            e.preventDefault();
            alert('⛔ Cutting is disabled for security reasons.');
            return false;
        };

        // Disable paste
        const disablePaste = (e) => {
            e.preventDefault();
            return false;
        };

        // Disable drag
        const disableDrag = (e) => {
            e.preventDefault();
            return false;
        };

        // Screenshot detection - blur/focus monitoring
        let screenshotAttempts = 0;
        const handleVisibilityChange = () => {
            if (document.hidden) {
                screenshotAttempts++;
                console.warn('⚠️ Potential screenshot attempt detected. Count:', screenshotAttempts);
                // You can send this to your server for logging
            }
        };

        const handleBlur = () => {
            console.warn('⚠️ Window lost focus - potential screenshot attempt');
        };

        // Prevent screen capture API
        const preventScreenCapture = () => {
            if (navigator.mediaDevices && navigator.mediaDevices.getDisplayMedia) {
                const originalGetDisplayMedia = navigator.mediaDevices.getDisplayMedia;
                navigator.mediaDevices.getDisplayMedia = function () {
                    alert('⛔ Screen recording/capture is not allowed on this page.');
                    return Promise.reject(new Error('Screen capture blocked'));
                };
            }
        };

        preventScreenCapture();

        // Add event listeners
        // document.addEventListener('contextmenu', disableRightClick);
        // document.addEventListener('keydown', disableKeyboardShortcuts);
        // document.addEventListener('keyup', disableKeyboardShortcuts);
        document.addEventListener('selectstart', disableSelection);
        document.addEventListener('copy', disableCopy);
        document.addEventListener('cut', disableCut);
        document.addEventListener('paste', disablePaste);
        document.addEventListener('dragstart', disableDrag);
        document.addEventListener('visibilitychange', handleVisibilityChange);
        window.addEventListener('blur', handleBlur);

        // Disable developer tools detection
        const detectDevTools = () => {
            const threshold = 160;
            const widthThreshold = window.outerWidth - window.innerWidth > threshold;
            const heightThreshold = window.outerHeight - window.innerHeight > threshold;

            if (widthThreshold || heightThreshold) {
                alert('⛔ Developer tools detected! Please close them immediately.');
                // Optionally redirect or hide content
                // window.location.href = 'about:blank';
            }
        };

        const devToolsInterval = setInterval(detectDevTools, 1000);

        // Detect debugger
        const detectDebugger = () => {
            debugger;
        };
        const debuggerInterval = setInterval(detectDebugger, 100);

        // Multiple watermark layers
        // const addWatermarks = () => {
        //   // Background pattern watermark
        //   const watermark1 = document.createElement('div');
        //   watermark1.id = 'watermark1';
        //   watermark1.style.cssText = `
        //     position: fixed;
        //     top: 0;
        //     left: 0;
        //     width: 100%;
        //     height: 100%;
        //     pointer-events: none;
        //     z-index: 9997;
        //     background-image: repeating-linear-gradient(
        //       45deg,
        //       transparent,
        //       transparent 150px,
        //       rgba(255, 0, 0, 0.08) 150px,
        //       rgba(255, 0, 0, 0.08) 300px
        //     );
        //   `;

        //   // Center watermark
        //   const watermark2 = document.createElement('div');
        //   watermark2.id = 'watermark2';
        //   watermark2.style.cssText = `
        //     position: fixed;
        //     top: 50%;
        //     left: 50%;
        //     transform: translate(-50%, -50%) rotate(-45deg);
        //     font-size: 60px;
        //     font-weight: bold;
        //     color: rgba(255, 0, 0, 0.15);
        //     pointer-events: none;
        //     z-index: 9998;
        //     white-space: nowrap;
        //     user-select: none;
        //     text-shadow: 2px 2px 4px rgba(0,0,0,0.1);
        //   `;
        //   watermark2.textContent = 'OMKATECH CONFIDENTIAL';

        //   // Multiple scattered watermarks
        //   const createScatteredWatermark = (top, left, rotation) => {
        //     const wm = document.createElement('div');
        //     wm.className = 'scattered-watermark';
        //     wm.style.cssText = `
        //       position: fixed;
        //       top: ${top}%;
        //       left: ${left}%;
        //       transform: rotate(${rotation}deg);
        //       font-size: 24px;
        //       font-weight: bold;
        //       color: rgba(255, 0, 0, 0.12);
        //       pointer-events: none;
        //       z-index: 9999;
        //       user-select: none;
        //     `;
        //     wm.textContent = 'OMKATECH ONLY';
        //     return wm;
        //   };

        //   // Timestamp watermark
        //   const timestampWatermark = document.createElement('div');
        //   timestampWatermark.id = 'timestamp-watermark';
        //   timestampWatermark.style.cssText = `
        //     position: fixed;
        //     bottom: 10px;
        //     right: 10px;
        //     font-size: 12px;
        //     color: rgba(255, 0, 0, 0.5);
        //     pointer-events: none;
        //     z-index: 10001;
        //     user-select: none;
        //     background: rgba(255, 255, 255, 0.8);
        //     padding: 5px 10px;
        //     border-radius: 5px;
        //   `;

        //   const updateTimestamp = () => {
        //     const now = new Date();
        //     timestampWatermark.textContent = `OMKATECH | ${now.toLocaleString()}`;
        //   };
        //   updateTimestamp();
        //   setInterval(updateTimestamp, 1000);

        //   document.body.appendChild(watermark1);
        //   document.body.appendChild(watermark2);
        //   document.body.appendChild(timestampWatermark);

        //   // Add scattered watermarks
        //   const positions = [
        //     [15, 20, -30], [25, 70, 25], [45, 15, -20],
        //     [65, 80, 30], [85, 40, -25], [75, 65, 20]
        //   ];

        //   positions.forEach(([top, left, rotation]) => {
        //     document.body.appendChild(createScatteredWatermark(top, left, rotation));
        //   });
        // };

        // addWatermarks();

        // // Continuous monitoring for watermark removal
        // const monitorWatermarks = () => {
        //   if (!document.getElementById('watermark1') || !document.getElementById('watermark2')) {
        //     alert('⛔ Security breach detected! Watermarks removed.');
        //     window.location.reload();
        //   }
        // };
        // const watermarkMonitor = setInterval(monitorWatermarks, 2000);

        // Clear clipboard continuously
        const clearClipboard = () => {
            if (navigator.clipboard && navigator.clipboard.writeText) {
                navigator.clipboard.writeText('').catch(() => { });
            }
        };
        const clipboardInterval = setInterval(clearClipboard, 500);

        // Cleanup event listeners on unmount
        return () => {
            //   document.removeEventListener('contextmenu', disableRightClick);
            //   document.removeEventListener('keydown', disableKeyboardShortcuts);
            //   document.removeEventListener('keyup', disableKeyboardShortcuts);
            document.removeEventListener('selectstart', disableSelection);
            document.removeEventListener('copy', disableCopy);
            document.removeEventListener('cut', disableCut);
            document.removeEventListener('paste', disablePaste);
            document.removeEventListener('dragstart', disableDrag);
            document.removeEventListener('visibilitychange', handleVisibilityChange);
            window.removeEventListener('blur', handleBlur);
            clearInterval(devToolsInterval);
            clearInterval(debuggerInterval);
            // clearInterval(watermarkMonitor);
            clearInterval(clipboardInterval);
        };
    }, [isAuthorized]);

    // Show loading while checking network
    // if (isChecking) {
    //     return (
    //         <div style={{
    //             display: 'flex',
    //             justifyContent: 'center',
    //             alignItems: 'center',
    //             height: '100vh',
    //             flexDirection: 'column',
    //             background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
    //             color: 'white'
    //         }}>
    //             <div style={{ fontSize: '48px', marginBottom: '20px' }}>🔒</div>
    //             <h2>Verifying Network Access...</h2>
    //             <p>Please wait while we verify you're on OMKATECH WiFi</p>
    //         </div>
    //     );
    // }

    // Show access denied if not authorized
    // if (!isAuthorized) {
    //     return (
    //         <div style={{
    //             display: 'flex',
    //             justifyContent: 'center',
    //             alignItems: 'center',
    //             height: '100vh',
    //             flexDirection: 'column',
    //             background: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)',
    //             color: 'white',
    //             padding: '20px',
    //             textAlign: 'center'
    //         }}>
    //             <div style={{ fontSize: '120px', marginBottom: '30px' }}>⛔</div>
    //             <h1 style={{ fontSize: '48px', marginBottom: '20px' }}>ACCESS DENIED</h1>
    //             <h2 style={{ fontSize: '24px', marginBottom: '30px' }}>
    //                 This page can only be accessed from OMKATECH Office WiFi Network
    //             </h2>
    //             <div style={{
    //                 background: 'rgba(255, 255, 255, 0.2)',
    //                 padding: '30px',
    //                 borderRadius: '15px',
    //                 maxWidth: '600px'
    //             }}>
    //                 <p style={{ fontSize: '18px', marginBottom: '15px' }}>
    //                     ⚠️ <strong>Security Notice:</strong>
    //                 </p>
    //                 <ul style={{ textAlign: 'left', fontSize: '16px', lineHeight: '1.8' }}>
    //                     <li>This content is confidential and restricted</li>
    //                     <li>Access is only permitted from authorized networks</li>
    //                     <li>Please connect to OMKATECH WiFi and try again</li>
    //                     <li>Unauthorized access attempts are logged</li>
    //                 </ul>
    //             </div>
    //             <p style={{ marginTop: '30px', fontSize: '14px', opacity: 0.8 }}>
    //                 If you believe this is an error, please contact IT support
    //             </p>
    //         </div>
    //     );
    // }'
    const IDLE_TIME = 10 * 60 * 1000; // 10 minutes

    function useIdleLogout(setStep) {
        const timerRef = useRef(null);
        const startedRef = useRef(false);

        const logoutUser = async () => {
            const token = localStorage.getItem('authToken');
            if (!token) return;

            try {
                await axios.post(
                    'https://newomkatech.omkatech.in/api/logout',
                    {},
                    { headers: { Authorization: `Bearer ${token}` } }
                );
            } catch (e) {
            } finally {
                localStorage.removeItem('authToken');
                setStep('email');
            }
        };

        const resetTimer = () => {
            clearTimeout(timerRef.current);
            timerRef.current = setTimeout(logoutUser, IDLE_TIME);
        };

        useEffect(() => {
            if (startedRef.current) return;
            startedRef.current = true;

            const events = [
                'mousemove',
                'mousedown',
                'keydown',
                'scroll',
                'touchstart',
            ];

            events.forEach(event =>
                window.addEventListener(event, resetTimer)
            );

            resetTimer();

            return () => {
                events.forEach(event =>
                    window.removeEventListener(event, resetTimer)
                );
                clearTimeout(timerRef.current);
            };
        }, []);
    }

    useEffect(() => {
        const handleUnload = () => {
            const token = localStorage.getItem('authToken');
            if (!token) return;

            const data = JSON.stringify({});

            navigator.sendBeacon(
                'https://newomkatech.omkatech.in/api/logout',
                new Blob([data], {
                    type: 'application/json',
                })
            );

            localStorage.removeItem('authToken');
        };

        window.addEventListener('beforeunload', handleUnload);

        return () => {
            window.removeEventListener('beforeunload', handleUnload);
        };
    }, []);

    useEffect(() => {
        const handleUnload = () => {
            const token = localStorage.getItem('authToken');
            if (!token) return;

            const navType = performance.getEntriesByType('navigation')[0]?.type;

            // 🚫 If refresh, do nothing
            if (navType === 'reload') return;

            navigator.sendBeacon(
                'https://newomkatech.omkatech.in/api/logout',
                new Blob([JSON.stringify({})], { type: 'application/json' })
            );

            localStorage.removeItem('authToken');
        };

        window.addEventListener('beforeunload', handleUnload);

        return () => {
            window.removeEventListener('beforeunload', handleUnload);
        };
    }, []);



    if (step === 'checking') {
        return <h2 style={{ textAlign: 'center' }}>Checking access...</h2>;
    }

    if (step === 'email') {
        return (
            <div style={styles.wrapper}>
                <div style={styles.card}>
                    <h2 style={styles.title}>Secure Access</h2>
                    <p style={styles.subtitle}>
                        Enter your company email to receive OTP
                    </p>

                    <input
                        type="email"
                        placeholder="Enter your official email ID"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        style={styles.input}
                    />

                    <button style={styles.button} onClick={sendOtp}>
                        CONFIRM
                    </button>
                </div>

                <div style={styles.note}>
                    <span style={styles.noteLabel}>Note:</span> Login is valid for 2 hours. Session will auto-expire after 10 minutes of inactivity or if the system is locked/off. Re-login via HR OTP will be required.
                </div>
            </div>
        );
    }

    if (step === 'otp') {
        return (
            <div style={styles.wrapper}>
                <div style={styles.card}>
                    <h2 style={styles.title}>OTP Verification</h2>
                    <p style={styles.subtitle}>
                        An OTP will be sent to hr@omkatech.com
                    </p>

                    <input
                        type="text"
                        placeholder="Enter 6-digit OTP"
                        value={otp}
                        onChange={(e) => setOtp(e.target.value)}
                        style={styles.input}
                        maxLength={6}
                    />

                    <button style={styles.buttonBlue} onClick={verifyOtp}>
                        CONTINUE
                    </button>
                </div>

                <div style={styles.note}>
                    <span style={styles.noteLabel}>Note:</span> Login is valid for 2 hours. Session will auto-expire after 10 minutes of inactivity or if the system is locked/off. Re-login via HR OTP will be required.
                </div>
            </div>
        );
    }

    if (step !== 'sop') return null;

    return (

        <div
            className="sop-container"
            style={{
                userSelect: 'none',
                WebkitUserSelect: 'none',
                MozUserSelect: 'none',
                msUserSelect: 'none',
                WebkitTouchCallout: 'none',
                KhtmlUserSelect: 'none'
            }}
            onMouseDown={(e) => e.preventDefault()}
            onContextMenu={(e) => e.preventDefault()}
        >
            {obscureContent && (
                <div style={{
                    position: 'fixed',
                    inset: 0,
                    backgroundColor: 'black',
                    zIndex: 9999,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                }}>
                    {/* <div style={{ color: 'red', fontSize: '48px', fontWeight: 'bold' }}>
                        ⛔ CONTENT PROTECTED ⛔
                    </div> */}
                </div>
            )}

            {/* Security Notice Banner */}
            {/* <div style={{
                position: 'fixed',
                top: 0,
                left: 0,
                right: 0,
                background: 'linear-gradient(90deg, #dc2626, #b91c1c, #991b1b)',
                color: 'white',
                padding: '12px',
                textAlign: 'center',
                zIndex: 10002,
                fontSize: '14px',
                fontWeight: 'bold',
                boxShadow: '0 4px 15px rgba(0,0,0,0.4)',
                borderBottom: '3px solid #7f1d1d'
            }}>
                🔒 CONFIDENTIAL - OMKATECH WIFI ONLY - Screenshots, Copying, Downloads & Screen Recording DISABLED | All Access Monitored & Logged
            </div> */}

            <div>
                {/* Rest of your content... */}
                <div className="sop-header">
                    <div className="sop-header-content">
                        <h1 className="sop-title">
                            Standard Operating Procedure (SOP) for Sales Team
                        </h1>
                        <p className="sop-subtitle">
                            This SOP defines the standard sales workflow to ensure timely follow-ups, accurate CRM updates, and consistent client communication across the sales team.
                        </p>
                        <div className="sop-info-box">
                            A step-by-step guide to handle leads efficiently and confidently.
                        </div>
                    </div>
                </div>

                <div className="sop-main">
                    <div className="sop-card one">
                        <p className="sop-intro-text">
                            Effective sales team management involves the establishment and adherence to standardized processes that govern various aspects of sales operations. This includes everything from initial prospecting through to closing deals and managing post-sales activities. 
                           
                            By incorporating SOPs, companies can ensure that their sales teams consistently follow best practices and operate in alignment with organizational goals and expectations.
                        </p>
                    </div>

                    <div className="sop-card-content">
                        <div className="sop-card table" ref={tocRef}>
                            <div className='table-one'>
                                <h2 className="sop-toc-title">Table of Contents</h2>
                                <ol className="sop-toc-list">
                                    {tocItems.map((item) => (
                                        <li
                                            key={item.id}
                                            onClick={() => scrollToSection(item.id)}
                                            className={`sop-toc-item ${activeId === item.id ? 'active' : ''
                                                }`}
                                        >
                                            {item.label}
                                        </li>
                                    ))}
                                </ol>
                            </div>
                                <div className='template-btn'>
                                    <Link to="/sales-sop/templates"> <button>View Templates</button> </Link>
                                </div>
                        </div>

                        <div className="sop-card-count-content">
                            <div className="sop-card" id="lead-flow">
                                <h2 className="sop-section-title">
                                    1. Lead Flow & Assignment
                                </h2>

                                <div>
                                    <div className="sop-subsection">
                                        <h3 className="sop-subsection-title">
                                            <span className="bullet">&bull;</span> Lead Shared by Marketing Team
                                        </h3>
                                        <p className="sop-subsection-text">
                                            The marketing team lead shares verified and relevant leads with the sales team. These leads are generated through campaigns, referrals, or inquiries.
                                        </p>
                                    </div>

                                    <div className="sop-subsection">
                                        <h3 className="sop-subsection-title"><span className="bullet">&bull;</span> Lead Uploaded to CRM</h3>
                                        <p className="sop-subsection-text">
                                            All received leads are uploaded into the CRM system. This ensures proper tracking, follow-ups, and performance monitoring.
                                        </p>
                                    </div>

                                    <div className="sop-subsection">
                                        <h3 className="sop-subsection-title"><span className="bullet">&bull;</span> Sales Executive Assignment</h3>
                                        <p className="sop-subsection-text">
                                            Leads are assigned to a sales executive either automatically or manually.The assigned executive becomes responsible for the complete lead journey.
                                        </p>
                                    </div>

                                    <div className="sop-subsection">
                                        <h3 className="sop-subsection-title"><span className="bullet">&bull;</span> Review Lead Details</h3>
                                        <p className="sop-subsection-text">
                                            The sales executive carefully reviews client information and source details. This helps in preparing the right communication approach.
                                        </p>
                                    </div>

                                    <div className="sop-subsection">
                                        <h3 className="sop-subsection-title"><span className="bullet">&bull;</span> Understand Client Requirements</h3>
                                        <p className="sop-subsection-text">
                                            The executive analyzes the client’s needs, budget, and expectations. Proper understanding improves conversion chances.
                                        </p>
                                    </div>

                                    <div className="sop-subsection">
                                        <h3 className="sop-subsection-title"><span className="bullet">&bull;</span> Initiate Client Communication</h3>
                                        <p className="sop-subsection-text">
                                            First contact is made through call, email, or WhatsApp professionally. Communication should be polite, clear, and solution-oriented.
                                        </p>
                                    </div>

                                    <div className="sop-subsection">
                                        <h3 className="sop-subsection-title"><span className="bullet">&bull;</span> Update CRM After Every Action</h3>
                                        <p className="sop-subsection-text">
                                            Every call, message, and email must be logged in CRM. Accurate updates help in tracking progress and future follow-ups.
                                        </p>
                                    </div>
                                </div>
                            </div>

                            <div className="sop-card" id="crm-lead-status">
                                <h2 className="sop-section-title">
                                    2. CRM Lead Status <span className="mandatory">(Mandatory)</span>
                                </h2>

                                <p className="sop-intro-text" style={{ marginBottom: '1rem' }}>
                                    Each lead must always have the correct CRM status to reflect its actual stage. Updating the right status helps in accurate tracking, follow-ups, and reporting.
                                </p>

                                <div>
                                    <details className="sop-accordion">
                                        <summary>
                                            Not Contacted
                                            <span className="sop-accordion-arrow">▼</span>
                                        </summary>
                                        <div className="sop-accordion-content">
                                            Lead has been assigned to the sales executive. No call, message, or email has been made yet.
                                        </div>
                                    </details>

                                    <details className="sop-accordion">
                                        <summary>
                                            Attempted to Contact
                                            <span className="sop-accordion-arrow">▼</span>
                                        </summary>
                                        <div className="sop-accordion-content">
                                            Contact has been attempted through call, email, or WhatsApp. Client has not responded yet.
                                        </div>
                                    </details>

                                    <details className="sop-accordion">
                                        <summary>
                                            Contacted
                                            <span className="sop-accordion-arrow">▼</span>
                                        </summary>
                                        <div className="sop-accordion-content">
                                            Communication with the client has been successfully established. Discussion has started regarding requirements or services.
                                        </div>
                                    </details>

                                    <details className="sop-accordion">
                                        <summary>
                                            Contact in Future
                                            <span className="sop-accordion-arrow">▼</span>
                                        </summary>
                                        <div className="sop-accordion-content">
                                            Client has requested a follow-up at a later date or time. Follow-up must be scheduled accordingly in CRM.
                                        </div>
                                    </details>

                                    <details className="sop-accordion">
                                        <summary>
                                            Pre-Qualified
                                            <span className="sop-accordion-arrow">▼</span>
                                        </summary>
                                        <div className="sop-accordion-content">
                                            Client has shown interest and meets basic criteria such as need and budget. Lead has potential to convert.
                                        </div>
                                    </details>

                                    <details className="sop-accordion">
                                        <summary>
                                            Lost Lead
                                            <span className="sop-accordion-arrow">▼</span>
                                        </summary>
                                        <div className="sop-accordion-content">
                                            Client is not moving forward or has chosen another vendor. No further follow-ups are required.
                                        </div>
                                    </details>

                                    <details className="sop-accordion">
                                        <summary>
                                            Junk Lead
                                            <span className="sop-accordion-arrow">▼</span>
                                        </summary>
                                        <div className="sop-accordion-content">
                                            Lead is invalid, irrelevant, or not related to our services. Such leads should be closed immediately.
                                        </div>
                                    </details>
                                </div>

                                <div className="sop-warning">
                                    <p className="sop-warning-text">
                                        ⚠️ <strong>Important:</strong> CRM status must be updated after every interaction to maintain data accuracy and sales discipline.
                                    </p>
                                </div>
                            </div>

                            <div className="sop-card" id="contact-management">
                                <h2 className="sop-section-title">
                                    3. Contact Management & Networking
                                </h2>

                                <ul className="sop-list">
                                    <li>
                                        <span className="sop-list-arrow">→</span>
                                        <span>Save client <span className="sop-highlight">phone number</span> and <span className="sop-highlight">email ID</span> correctly.</span>
                                    </li>
                                    <li>
                                        <span className="sop-list-arrow">→</span>
                                        <span>Connect with the client on <span className="sop-highlight">LinkedIn</span> (if available).</span>
                                    </li>
                                    <li>
                                        <span className="sop-list-arrow">→</span>
                                        <span>Check <span className="sop-highlight">WhatsApp availability</span> for follow-ups.</span>
                                    </li>
                                    <li>
                                        <span className="sop-list-arrow">→</span>
                                        <span>Maintain professional communication across all platforms.</span>
                                    </li>
                                </ul>
                            </div>

                            <div className="sop-card" id="follow-up">
                                <h2 className="sop-section-title">
                                    4. 5-Day Follow-Up Process
                                </h2>

                                <div className="sop-followup-grid">
                                    <div className="sop-day-card">
                                        <h3 className="sop-day-title">Day 1:</h3>
                                        <ul className="sop-day-list">
                                            <li>• Set follow-up in CRM</li>
                                            <li>• Send introductory email</li>
                                            <li>• Use provided email templates</li>
                                        </ul>
                                    </div>

                                    <div className="sop-day-card">
                                        <h3 className="sop-day-title">Day 2:</h3>
                                        <ul className="sop-day-list">
                                            <li>• Send WhatsApp follow-up message</li>
                                            <li>• Keep it short and professional</li>
                                        </ul>
                                    </div>

                                    <div className="sop-day-card">
                                        <h3 className="sop-day-title">Day 3:</h3>
                                        <ul className="sop-day-list">
                                            <li>• Send email follow-up</li>
                                            <li>• Make a follow-up call</li>
                                            <li>• Update CRM status and notes</li>
                                        </ul>
                                    </div>

                                    <div className="sop-day-card">
                                        <h3 className="sop-day-title">Day 4:</h3>
                                        <ul className="sop-day-list">
                                            <li>• Send WhatsApp follow-up</li>
                                            <li>• Avoid spamming, stay respectful</li>
                                        </ul>
                                    </div>

                                    <div className="sop-day-card full-width">
                                        <h3 className="sop-day-title">Day 5:</h3>
                                        <ul className="sop-day-list">
                                            <li>• Send follow-up email</li>
                                            <li>• Drop a short text message</li>
                                            <li>• Update CRM status:</li>
                                        </ul>

                                    </div>
                                </div>
                                <div className="view-btn sop-template-btn">
                                    <p> View Sample Template</p>
                                    <Link className='portfolio-page' to="/sales-sop/templates"><span><button>
                                        View
                                    </button></span>
                                    </Link>
                                </div>
                            </div>

                            <div className="sop-card" id="communication">
                                <h2 className="sop-section-title">
                                    5. Communication Guidelines
                                </h2>

                                <ul className="sop-list">
                                    <li>
                                        <span className="sop-list-arrow">→</span>
                                        <span>Be polite, professional, and confident.</span>
                                    </li>
                                    <li>
                                        <span className="sop-list-arrow">→</span>
                                        <span>Do not blindly copy templates.</span>
                                    </li>
                                    <li>
                                        <span className="sop-list-arrow">→</span>
                                        <span>Customize messages based on:</span>
                                    </li>
                                    <ul className="sop-nested-list">
                                        <li>• Client type</li>
                                        <li>• Industry</li>
                                        <li>• Requirements</li>
                                    </ul>
                                    <li>
                                        <span className="sop-list-arrow">→</span>
                                        <span>Never overpromise</span>
                                    </li>
                                    <li>
                                        <span className="sop-list-arrow">→</span>
                                        <span>Maintain proper CRM notes</span>
                                    </li>
                                </ul>
                            </div>

                            <div className="sop-card" id="crm-discipline">
                                <h2 className="sop-section-title">
                                    6. CRM Discipline (Strictly Mandatory)
                                </h2>

                                <ul className="sop-list">
                                    <li>
                                        <span className="sop-list-arrow">→</span>
                                        <span>Log every call, email, and message.</span>
                                    </li>
                                    <li>
                                        <span className="sop-list-arrow">→</span>
                                        <span>Update lead status accurately.</span>
                                    </li>
                                    <li>
                                        <span className="sop-list-arrow">→</span>
                                        <span>Never miss follow-ups</span>
                                    </li>
                                    <li>
                                        <span className="sop-list-arrow">→</span>
                                        <span>CRM is the single source of truth.</span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    <div className="sop-compliance" id="compliance">
                        <p className="sop-compliance-text">
                            <strong>Compliance Note:</strong> Following this SOP is mandatory for all sales executives. This process helps improve lead conversion, transparency, and sales performance.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
};

const styles = {
    wrapper: {
        minHeight: 'calc(100vh - 110px)',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        background: '#fff',
        fontFamily: 'system-ui, -apple-system, sans-serif',
        padding: '20px',
        position: 'relative'
    },

    card: {
        width: '100%',
        maxWidth: '400px',
        padding: '40px 36px',
        borderRadius: '12px',
        background: '#FAFAFA',
        boxShadow: '0 4px 20px rgba(0, 0, 0, 0.08)',
        border: '1px solid #e5e7eb',
        textAlign: 'left',
        marginBottom: '40px',
    },

    title: {
        color: '#1F58F1',
        fontSize: '28px',
        fontWeight: '600',
        margin: '0 0 8px 0',
    },

    subtitle: {
        color: '#4b5563',
        fontSize: '14px',
        marginBottom: '24px',
        fontWeight: '400',
        lineHeight: '1.5',
    },

    input: {
        width: '100%',
        padding: '12px 16px',
        borderRadius: '8px',
        border: '1px solid #d1d5db',
        background: '#ffffff',
        color: '#1f2937',
        outline: 'none',
        fontSize: '14px',
        marginBottom: '18px',
        boxSizing: 'border-box',
    },

    button: {
        width: '100%',
        padding: '14px',
        borderRadius: '8px',
        border: 'none',
        background: '#C0D1FF',
        color: '#1F58F1',
        fontSize: '15px',
        fontWeight: '600',
        cursor: 'pointer',
        letterSpacing: '0.5px',
    },

    note: {
        width: '100%',
        maxWidth: '1200px',
        bottom: '50px',
        position: 'absolute',
        padding: '16px 24px',
        background: '#ECF9FE',
        borderRadius: '8px',
        color: '#303030',
        fontSize: '16px',
        lineHeight: '1.6',
        textAlign: 'center'
    },

    noteLabel: {
        fontWeight: '600',
        marginRight: '6px',
    },
    buttonBlue: {
        width: '100%',
        padding: '14px',
        borderRadius: '8px',
        border: 'none',
        background: '#1F58F1',
        color: '#ffffff',
        fontSize: '15px',
        fontWeight: '600',
        cursor: 'pointer',
        letterSpacing: '0.5px',
    },
};
